import { GraphKinds, IRangeOfMotionBehavior, ILineGraphBehavior } from "../../../../../../documaker/domain/format/objects";
import { IGraphObject } from "../../../../../domain/editableFormat/objects";
import { IGraphObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { RectangleCoordinatableObjectTranslator } from "./base";
import { LineGraphItemsTranslator } from "./properties";

export class GraphObjectTranslator extends AbstractObjectTranslator<IGraphObject, IGraphObjectBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  protected shouldRecordName(source: IGraphObjectBean): boolean {
    return (source["@type"] === "2");
  }

  overwriteObject(source: IGraphObject, bean: IGraphObjectBean, formatId: number): void {
    source.kind = this.integer.from(bean["@type"]);
    this._overwriters[source.kind].overwriteFrom(source, bean);
  }

  overwriteBean(source: IGraphObjectBean, object: IGraphObject): void {
    source["@type"] = this.integer.to(object.kind);
    source["@orientation"] = "1";                       // 1固定.(グラフによらず.)
    this._overwriters[object.kind].overwriteTo(source, object);
  }

  private readonly _overwriters: { [key in GraphKinds]: { overwriteFrom: (s: IGraphObject, b: IGraphObjectBean) => void, overwriteTo: (s: IGraphObjectBean, o: IGraphObject) => void } }
    = {
      1: {  // RangeOfMotion.
        overwriteFrom: (s, b) => {
          s.behavior = {
            range: {
              min: this.integer.from(b["@min"]),
              max: this.integer.from(b["@max"]),
            },
            manualMuscleTestBahavior: {
              inputMethod: this.integer.from(b["@input"]),
              presentMethod: this.integer.from(b["@muscular-strength"]),
            },
          };
        },
        overwriteTo: (s, o) => {
          const behavior = o.behavior as IRangeOfMotionBehavior;
          s["@low-value"] = "";                                                                       // フォーマット編集未使用.
          s["@high-value"] = "";                                                                      // フォーマット編集未使用.
          s["@min"] = this.integer.to(behavior.range.min);
          s["@max"] = this.integer.to(behavior.range.max);
          s["@input"] = this.integer.to(behavior.manualMuscleTestBahavior.inputMethod);
          s["@muscular-strength"] = this.integer.to(behavior.manualMuscleTestBahavior.presentMethod);
          s["@scale"] = "1";                                                                          // 折れ線グラフ用.
        },
      }, 
      2: {  // Line.
        overwriteFrom: (s, b) => {
          s.behavior = {
            commonTimeAxis: {
              isEnable: (b["@scale"] === "2"),
            },
            border: {
              isEnable: (b["@border"] !== "0"),
            },
            horizontalGrid: {
              isEnable: (b["@grid-h"] !== undefined),
              divisionCount: this.integer.from(b["@grid-h"]),
            },
            items: this.lineItems.from(b),
          };
        },
        overwriteTo: (s, o) => {
          const behavior = o.behavior as ILineGraphBehavior;
          s["@low-value"] = "";                                                                       // フォーマット編集未使用.
          s["@high-value"] = "";                                                                      // フォーマット編集未使用.
          s["@min"] = "0";                                                                            // 関節可動域用.
          s["@max"] = "100";                                                                          // 関節可動域用.
          s["@input"] = "1";                                                                          // 関節可動域用.
          s["@muscular-strength"] = "1";                                                              // 関節可動域用.
          s["@scale"] = behavior.commonTimeAxis.isEnable ? "2" : "1";
          s["@border"] = behavior.border.isEnable ? undefined : "0";
          s["@grid-h"] = behavior.horizontalGrid.isEnable ? this.integer.to(behavior.horizontalGrid.divisionCount) : undefined;
          s.graphitem = this.lineItems.to(behavior);
        },
      }, 
    };

  private readonly lineItems = new LineGraphItemsTranslator();
}
